import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import useSeoData from '../hooks/useSeoData';

const SEO = ({ 
  fallbackTitle, 
  fallbackDescription, 
  canonicalUrl,
  structuredData,
  imageUrl,
  type = 'website'
}) => {
  const location = useLocation();
  const currentUrl = window.location.origin + location.pathname;
  const { seoData } = useSeoData(location.pathname, fallbackTitle, fallbackDescription);

  // Use canonical URL if provided, otherwise use current URL
  const canonicalLink = canonicalUrl || currentUrl;
  
  // Set image URL with fallback
  const ogImage = imageUrl || seoData.image || `${window.location.origin}/logo.png`;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      <link rel="canonical" href={canonicalLink} />

      {/* Open Graph meta tags */}
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.description} />
      <meta property="og:url" content={canonicalLink} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoData.title} />
      <meta name="twitter:description" content={seoData.description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Structured data if provided */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO; 